export default "__VITE_ASSET__BfgYJxo5__"